<template>
    <b-overlay :show="showoverlay" rounded="sm">
        <div class="card rounded-border bg-wash no-shadow">
            <div class="card-header ">
                <div class="card-header-inner clearfix my-3">
                    <div class="float-left align-self-center pt-1 col-sm-4 px-0" style="font-size: 18px;">Total employees <span class="ml-2" style="color: #5A8DEE;">{{people}}</span></div>
                    <div class="float-left align-self-center col-sm-8 custom-search pr-0">
                        <b-input-group >
                            <b-input-group-prepend is-text>
                                <b-icon icon="search"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input type="search" placeholder="Search..." v-model="search" @input="setSearch()"></b-form-input>
                        </b-input-group>
                    </div>
                </div>
            </div>
            <div class="card-body container px-0 pt-0">
                <table class="table table-borderless employee-list-table">
                    <tbody>
                        <tr class="table-head">
                            <th v-for="column in columns" :key="column.name" @click="sortBy(column.name)":class="sortKey === column.name ? (sortOrders[column.name] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'" style="cursor:pointer;"><span>{{column.label}}</span></th>

                            <td class="text-right">Action</td>
                        </tr>

                        <template v-if="paginatedData">
                            <tr class="table-row hover-bg" v-for="employee_data in paginatedData" :key="employee_data.employee_id">
                                <td>
                                    <img v-if="employee_data.pic != 'no-image.jpg' && employee_data.pic != ''" v-bind:src="$api_url+'/avatar/'+ employee_data.company_id + '/' + employee_data.pic" class="img-fluid img-thumbnail employee-avatar mr-2" />
                                    <img v-else v-bind:src="$api_url+'/avatar/demo.jpg'" class="img-fluid img-thumbnail employee-avatar mr-2" />
                                    {{employee_data.name}}
                                </td>

                                <td>{{employee_data.jobposition}}</td>
                                <td>{{employee_data.department}}</td>
                                <td>{{employee_data.employee_code}}</td>
                                <td class="position-relative text-right">
                                    <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                                    <div class="dropdown-menu action-dropdown-menu px-1" aria-labelledby="actionDropdown">
                                        <b-button class="text-left" variant="secondary" @click="updateContract(employee_data.employee_id,employee_data.name, employee_data.active_contract)">Update</b-button>
                                    </div>
                                </td>
                            </tr>
                        </template>

                    </tbody>
                </table>
                <div class="row py-2 no-margin" v-if="paginatedData.length > 0">
                    <div class="col-md-12 p-0 no-margin" v-if="paginatedData.length > 0">
                        <ul class="pagination b-pagination float-left mb-0 mt-1">
                            <li class="page-item disabled m-2">View</li>
                            <li class="page-item disabled"><b-form-select v-model="temp_length" :options="length_options" @change="setFirstPage()"></b-form-select></li>
                            <li class="page-item disabled m-2">per page. Total {{people}} records found.</li>
                        </ul>
                        <b-pagination-nav class="float-right mt-1" v-model="pagination.currentPage" :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#" first-number last-number ></b-pagination-nav>
                    </div>

                </div>
                <div class="row p-4 no-gutters justify-content-center align-items-center" v-if="paginatedData.length == 0">
                    <p class="mb-0 mr-3">{{blankmsg}}</p><b-button variant="primary" class="mb-0" :href="'/employee/info'">Add Employee</b-button>
                </div>
            </div>

            <b-modal id="bv-modal-update-form-contract" hide-footer  title="Contract change" size="lg">
                <b-form @submit.stop.prevent="popupSubmit">
                    <b-overlay :show="popupoverlay" rounded="sm">
                        <template v-if="curr_emp_id != 0">
                            <contract-wizard  :employee_id="curr_emp_id" :contract_id="curr_contract_id"></contract-wizard>
                        </template>
                    </b-overlay>
                </b-form>
            </b-modal>

        </div>
    </b-overlay>
</template>
<style scoped>
button.disabled{cursor: default;}
</style>

<script>
    export default{
        data(){
            let sortOrders = {};
            let columns = [
                            {label: 'Name', name: 'name' },
                            {label: 'Job Position', name: 'jobposition'},
                            {label: 'Department', name: 'department'},
                            {label: 'Employee Code', name: 'employee_code'},
                        ];
            columns.forEach((column) => {sortOrders[column.name] = -1;});

            return {

                company_name: '',
                emp_list_data : [],
                showoverlay : true,
                popupoverlay: true,
                empdata: [],
                m_search_data: [],
                emp_pf_title: '',
                emp_btn_title: '',

                curr_emp_name: '',
                curr_emp_id: 0,
                curr_contract_id: 0,
                leave_date: '',

                notice: "",
                blankmsg : 'Fetching data..',
                people:0,

                search:'',

                columns: columns,
                sortKey: 'name',
                sortOrders: sortOrders,
                length : 20,
                // Abdullah26 chnaged to 20
                temp_length: 20,
                pagination : {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', pages:1},
                // Abdullah26 chnaged length options
                length_options:
                [
                    { value: 20, text: "20" },
                    { value: 50, text: "50" },
                    { value: 100, text: "100" }
                ],

            }
        },
        methods:{

            getAcl: function()
            {
                axios.get(this.$api_url+'/acl' , {
                    params: {
                        url: this.cu
                    }
                }).then(function(response){
                    this.ce = response.data;
                }.bind(this));
            },
            getEmployeeListData: function(){
            let currentObj = this;
            this.showoverlay = true;
              axios.get(this.$api_url+'/employee/filteredlist', {
                    params: {
                        status: 1,
                        per_page: this.length,
                        s_page: this.pagination.currentPage,
                        s_key: this.search
                    }
                    })
              .then(function (response) {

                this.showoverlay = false;
                if(response.data.data)
                    this.emp_list_data = response.data.data.employees;

                if(response.data.data == 0)
                    this.blankmsg = "Nothing found.";

                else
                    this.sortBy('name');


                this.people = this.emp_list_data.length;
                //this.length = response.data.data.per_page;
                 //this.pagination.currentPage = response.data.data.current_page;
                 //console.log(this.emp_list_data);

                //this.paginate(response.data.data.total, this.length, this.pagination.currentPage)
              }.bind(this)).catch(function (error){currentObj.showoverlay = false; currentObj.serverError(error);});

            },
            updateContract: function(emp_id,emp_name,emp_contract)
            {
            //this.popupoverlay = true;
            this.curr_emp_name = emp_name;
            this.curr_emp_id = emp_id;
            this.curr_contract_id = emp_contract;
            this.popupoverlay = false;
            this.$bvModal.show('bv-modal-update-form-contract');
           },
           popupSubmit(e)
            {
                e.preventDefault();
                let currentObj = this;
                const config = {
                    headers: { 'content-type': 'multipart/form-data' }
                }
                let formData = new FormData();
                formData.append('employee_id', this.curr_emp_id);
                if(this.leave_date && (new Date(this.leave_date) - new Date() >= 0 )){
                    axios.post(this.$api_url+'/saveleaverdata', formData, config)
                            .then(function (response)
                            {
                                if(response.data.success){
                                 this.$bvToast.toast("Successfully marked as leaver", {title: 'Success',variant: 'success',solid: true});
                                }
                            }.bind(this))
                            .catch(function (error)
                            {
                                currentObj.errormsg = error.response.data.errors;
                            });

                }else{
                    this.$bvToast.toast("Please enter valid date", {title: 'Error!',variant: 'danger',solid: true});
                }
            }
        },
        created: function(){
            this.getAcl();
            this.getEmployeeListData();
        },
        computed:
        {
            filteredData()
            {
                let filtered_list = this.emp_list_data;
                if (this.search)
                {
                    filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});

                    if(filtered_list.length == 0)
                        this.blankmsg = "Nothing found.";
                }

                let sortKey = this.sortKey;
                let order = this.sortOrders[sortKey] || 1;
                if (sortKey)
                {
                    filtered_list = filtered_list.slice().sort((a, b) => {let index = this.getIndex(this.columns, 'name', sortKey);
                            a = String(a[sortKey]).toLowerCase();
                            b = String(b[sortKey]).toLowerCase();
                            if (this.columns[index].type && this.columns[index].type === 'date')
                            {
                                return (a === b ? 0 : new Date(a).getTime() > new Date(b).getTime() ? 1 : -1) * order;
                            }
                            else if (this.columns[index].type && this.columns[index].type === 'number')
                            {
                                return (+a === +b ? 0 : +a > +b ? 1 : -1) * order;
                            }
                            else
                            {
                                return (a === b ? 0 : a > b ? 1 : -1) * order;
                            }
                        }
                    );
                }

                return filtered_list;
            },
            paginatedData()
            {
                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            }
        }
    }
</script>
